<template>
  <basic-container>
    <el-form ref="searchForm" :model="query" label-width="100px" margin-top = "0" id="searchForm_iotDevice">
      <el-col :span="5">
        <el-form-item label="项目名称">
          <el-select
            v-model="query.projectId"
            placeholder="请选择项目名称"
            style="width: 100%"
            @change="initAreaList"
          >
            <el-option
              v-for="item in projectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item label="区域">
          <el-select
            v-model="query.areaId"
            placeholder="请选择存放区域"
            style="width: 100%"
          >
            <el-option
              :value="query.areaId"
              show-all-levels
              :label="query.areaName"
            >
              <el-tree
                node-key="id"
                :data="treeFormAreaData"
                :props="treeProps"
                ref="areadTree"
                :load="searchAreaLazyLoadTree"
                lazy
                @node-click="searchAreaNodeTreeClick"
              >
              </el-tree>
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item label="仪表名称">
          <el-input maxlength="30" v-model="query.meterName"   show-word-limit></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="5">
        <el-form-item label="仪表类型" prop="meterType">
          <el-select
            v-model="query.meterType"
            placeholder="请选择仪表类型"
            style="width:100%"
            @change="meterTypeChange"
          >
            <el-option
              v-for="item in meterTypeList"
              :key="item.dictKey"
              :label="item.dictValue"
              :value="item.dictKey"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-button size="small" icon="el-icon-search"  type="primary" @click="search" style="margin-right:5px;">
          搜 索
        </el-button>
        <el-button size="small" icon="el-icon-delete"  @click="searchReset" style="margin-left:5px;">
          重 置
        </el-button>
      </el-col>
    </el-form>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"

               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @on-load="onLoad"
               @refresh-change="onLoad"
    >
    </avue-crud>
    <el-dialog
      id="iod_device_form"
      :title="operateName"
      :visible.sync="showOperateDialog"
      :modal-append-to-body="false"
      width="900px"
      @close="closeDialog"
    >
      <el-row v-if="showOperateDialog">
        <el-form ref="operateForm"  :model="form" label-width="100px" margin-top = "0" id="operateForm_iotDevice" :rules="formRules">
          <el-col :span="8">
            <el-form-item label="项目名称" prop="projectId">
              <el-select
                v-model="form.projectId"
                placeholder="请选择项目名称"
                style="width: 100%"

                @change="projectSearchChange"
                :disabled="true"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="所属区域" prop="areaId">

              <el-select
                v-model="form.areaId"
                placeholder="请选择存放区域"
                style="width: 100%"
                :disabled="editDisabled"
                @change="projectSearchChange"
              >
                <el-option
                  :value="form.areaId"
                  show-all-levels
                  :label="form.areaName"
                >
                  <el-tree
                    node-key="id"
                    :data="treeFormAreaData"
                    :props="treeProps"
                    ref="areadTree2"
                    :load="searchAreaLazyLoadTree"
                    lazy
                    @node-click="formAreaNodeTreeClick"
                  >
                  </el-tree>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仪表类型" prop="meterType" >
              <el-select
                v-model="form.meterType"
                placeholder="请选择仪表类型"
                style="width: 100%"
                @change="projectSearchChange"
                :disabled="editDisabled"
              >
                <el-option
                  v-for="item in meterTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="抄表日期" prop="collectTime" >
              <el-date-picker
                v-model="form.collectTime"
                placeholder="请输入抄表日期"
                :disabled="editDisabled"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <!--==============================================-->
          <avue-crud :data="paramData"
                     :before-open="addBeforeOpen"
                     :option="viewOption"
                     v-model="form">

            <template slot-scope="scope" slot="nowNums">
              <el-form-item :rules="[{required: true,message:'请输入本期止码',trigger: 'blur'}]">
                <el-input
                v-model="scope.row.nowNums"
                type="text" placeholder="请输入"
                v-bind:disabled="nowNumdisabled"
                @input="e=>inputnowNumsdata(scope.row,e)"
                @blur="nowNumsdata(scope.row,Number(scope.row.nowNums))"></el-input>
              </el-form-item>
            </template>
          </avue-crud>
          <!--===============================================================-->


          <el-col :span="6" offset="18">
            <el-button icon="el-icon-circle-check" v-model="form" type="primary" @click="saveData(form)" v-if="!editDisabled">
              保存
            </el-button>
            <el-button icon="el-icon-circle-close" @click="closeDialog"  v-if="!editDisabled">
              取消
            </el-button>
          </el-col>
        </el-form>
      </el-row>


    </el-dialog>
  </basic-container>
</template>

<script>
  import {saveParamData, getList, remove, update,getParamsList,getParamsByparamId,getProjectList,getParamsData,viewParamData} from "@/api/crmedical/energy/energymeterhandwritten";
  import {mapGetters} from "vuex";
  import { lazyTree } from "@/api/crmedical/project/area";
  import { getDictionary } from "@/api/system/dict";
  export default {
    data() {

      return {
        addFormDataFlag:true,
        deviceList: [],
        projectList: [],
        treeFormAreaData: [],
        showOperateDialog: false,
        nowNumdisabled:false,
        treeProps: {
          //标题
          label: "name",
          //值
          value: "id",
          //子节点
          children: "zones",
          //是否叶子节点
          isLeaf: "hasChildren",
          //本节点类型key值
          objectType: "id",
          //本节点类型名
          objectTypeName: "name",
        },
        disabled:false,
        form: {
          projectId: '',
          parentName: '',
          parentId: '',
          areaId: '',
          areaName: '',
          meterType: '',
          collectNum:'',
          meterName:'',
          meterNo:'',
          collectTime:'',
          createTimes:'',
          newnums:'',
          nowEnergy:''
        },

        query: {
          projectId: '',
          areaId: '',
          areaName:'',
          meterType:'',
        },
        loading: true,
        selectionList: [],
        meterModelList: [],
        meterModelAllList: [],
        paramData:[{
          nowNums: "",
          nowEnergy:"",
        }],
        paramList:[],
        meterTypeList: [],
        option: {
          height: 'auto',
          calcHeight: 50,
          tip: false,
          border: true,
          index: true,
          indexLabel: "序号",
          viewBtn: true,
          selection: false,
          editBtn:false,
          delBtn: false,
          searchMenuSpan: 6,
          columnBtn: false,
          refreshBtn: false,
          column: [
            {
              label: "主键",
              prop: "id",
              editDisplay: false,
              addDisplay: false,
              viewDisplay: false,
              hide: true,
            },
            {
              label: "项目名称",
              prop: "proName",
              addDisplay: false,
            },
            {
              label: "区域",
              prop: "areaName",
              type: 'select',
              addDisplay: false,
            },
            {
              label: "仪表类型",
              prop: "meterType",
              type: 'select',
              addDisplay: false,
              dataType: 'number',
              dicUrl: 'api/blade-system/dict/dictionary?code=meter_type',
              props: { label: 'dictValue', value: 'dictKey' },
            },

            {
              label: "仪表编号",
              prop: "meterNo",
              addDisplay:false
            },
            {
              label: "仪表名称",
              prop: "meterName",
              addDisplay:false
            },
            {
              prop: 'table',
              formlot: true,
              labelslot: true,
              span: 24,
              row:true,
              hide: true,
            },
            {
              label: "本期能耗",
              prop: "costNum",
              maxlength: 30,
              showWordLimit: true,
              overHidden: true,
              addDisplay:false,
              rules: [{
                required: true,
                message: "请输入品牌名称",
                trigger: "blur"
              }]
            },
            {
              label: "抄表日期",
              prop: "collectTime",
              className:'formClassName',
              addDisplay:false,
              hide: false,
              type: "datetime",
              format: "yyyy-MM-dd",
              valueFormat: "timestamp",
              rules: [{
                required: true,
                message: "请选择抄表日期",
                trigger: "blur"
              }]
            },
          ]
        },
        viewOption: {
          calcHeight: 50,
          page: false,
          border: true,
          addBtn: false,
          selection: false,
          tip: false,
          columnBtn: false,
          refreshBtn: false,
          delBtn:false,
          menuAlign: "center",
          menu: false,
          column: [
            {
              label: "主键",
              prop: "id",
              editDisplay: false,
              addDisplay: false,
              viewDisplay: false,
              hide: true,
            },
            {
              label: "仪表名称",
              prop: "meterName",
              maxlength: 200,
              showWordLimit: true,
              overHidden: true,
            },
            {
              label: "仪表编号",
              prop: "meterNo",
              maxlength: 200,
              showWordLimit: true,
              overHidden: true,
            },
            {
              label: "所属区域",
              prop: "areaName",

            },
            {
              label: "上期止码",
              prop: "endNum"
            },
            {
              label: "上期抄表日期",
              type:"datetime",
              format: "yyyy-MM-dd",
              valueFormat: "timestamp",
              prop: "updateTime"
            },
            {
              label: "本期止码",
              prop: "nowNums",
              slot:true,
            },
            {
              label: "本期能耗",
              prop: "nowEnergy",
            },
          ],
        },
        onLoadFlag:true,
        data: [],
        formRules: {
          projectId: [{required: true, message: "请选择项目名称", trigger: "change"}],
          areaId: [{required: true, message: "请输入所属区域", trigger: "change"}],
          meterType: [{required: true, message: "请选择仪表类型", trigger: "change"}],
          collectTime: [{required: true, message: "请选择抄表日期", trigger: "change"}],
        },
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    created(){
      this.initData()
    },
    methods: {
      async initData(){
        await getProjectList().then((data) => {
          this.projectList = data.data;

        });
        this.query.projectId = this.projectList[0]?this.projectList[0].id:'';
        this.onLoadFlag = false;
        this.onLoad()
        await this.initAreaList();
        //加载仪表类型列表
        await getDictionary({code:'meter_type'}).then((res) => {
          this.meterTypeList = res.data.data;
        });
        // await getMeterModelList().then((res) => {
        //   this.meterModelAllList = res.data;
        // })

      },
      changeMeasuringFlag(id){
        this.paramData.forEach(ele=>{
          if(ele.id == id ){
            ele.measuringFlag = true;
          }else{
            ele.measuringFlag = false;
          }
        })
      },

      // 获取仪表参数下拉列表数据
      getParamsList(){
        getParamsList({meterType:this.form.meterType,name:this.form.name}).then(res=>{
          // if(res.data[0]==''){
          //   this.paramList = [];
          // }else{
          //   this.paramList = res.data;
          // }
          // this.$forceUpdate();

        })
      },
      formAreaNodeTreeClick(node){
        this.form.areaId = node.id;
        this.form.areaName = node.name;
        this.getParamsData();
      },
      // 根据 项目id 类型id 区域id 获取仪表list
      getParamsData(){
        if(!(this.form.areaId&&this.form.projectId&&this.form.meterType)){
          return;
        }
        getParamsData(
              {
                areaId:this.form.areaId,
                proName:this.form.projectId,
                meterType:this.form.meterType,
              }
              ).then(({data}) => {
                if(data[0]==''){
                  this.paramData = [];
                }else{
                   data.forEach(ele=>{
                      ele.nowEnergy=0;
                      ele.nowNums='';
                    })
                  this.paramData = data;
                }
                this.$forceUpdate();
            });
      },

      // 切换参数  更具仪表参数获取其他内容
      changeParams(val,row){
        getParamsByparamId({id:val}).then(({data})=>{
          row.paramCode = data.code,
          row.measuringUnitName=data.measuringUnitName,
          row.mappingParamName='';
          let temArr = [];
          this.paramData.forEach(ele=>{
            temArr.push(ele);
          })
          this.paramData = temArr;
          this.$forceUpdate();
          //  this.paramData = Object.assign({},this.paramData,temOBj);
          console.log(this.paramData)
        })
      },
      // 提交
      saveData(row) {

        this.$refs.operateForm.validate((valid) => {
          if(valid){
             if(this.paramData.length<1){
              this.$message.warning("没有仪表，无法保存!");
              return;
            }
            this.paramData.forEach(ele=>{
              if(!ele.nowNums){
                this.$message.warning('请输入 '+ele.meterName+' 本期止码!');
                throw new Error('请输入 '+ele.meterName+' 本期止码!')
              }
              if(ele.endNum>ele.nowNums){
                this.$message.warning(ele.meterName+'的本期止码不得小于上期止码!');
                throw new Error(ele.meterName+'的本期止码不得小于上期止码!')
              }
            })
            this.form.paramData = this.paramData;
            this.form.collectTime = this.dayjs(this.form.collectTime).format('YYYY-MM-DD 00:00:00')
            saveParamData(this.form).then(() => {

              this.closeDialog();
              this.onLoad();
              this.showOperateDialog = false;
              this.$message.success('操作成功!');
            }, error => {
              this.loading = false;
              window.console.log(error);
            });
          }
        });
      },
      rowSave(row, loading, done) {
        let temArr  = [];
        let flag = false;
        this.paramData.forEach(ele=>{
          let temObj = {
            mappingParamName:ele.mappingParamName,
            measuringFlag:ele.measuringFlag?1:0,
            measuringUnitName: ele.measuringUnitName,
            paramCode: ele.paramCode,
            paramId: ele.paramId,
          };
          if(ele.measuringFlag){
            flag = true;
          }
          temArr.push(temObj);

        })
        if(!flag){
          this.$message({
            message: '请选择计量参数',
            type: 'warning'
          });
          done();
          return;
        }
        row.energyMeterModelParamList = temArr;
        add(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowUpdate(row, index, loading, done) {
        update(row).then(() => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        }, error => {
          done();
          console.log(error);
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      search(){
        this.page.currentPage = 1;
        this.onLoad();
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      // 打开弹窗
      beforeOpen(from, type) {
        this.paramData ="";
        this.nowNumdisabled = false;
        if(type === 'add'){
          this.form.collectTime = this.dayjs();
          this.form.meterType = '';
          this.form.projectId = this.query.projectId;
          // this.getParamsData();

          this.operateName = '新增';
          this.editDisabled =false;
        }else if(type === 'view'){
          this.form.meterType = String(this.form.meterType);
          this.form.projectId = this.query.projectId;
          this.nowNumdisabled = true;
          viewParamData(
            {id:this.form.id}
          ).then(({data}) => {
            data.forEach(ele=>{
              ele.nowNums =  ele.nowEndNum;
              ele.nowEnergy =  ele.costNum;
            })
            this.paramData = data;
          });
          this.operateName = '查看';
          this.editDisabled = true
        }
        this.showOperateDialog = true;
      },
      // 控制止码的长度
      omitNumber(e) {
        let value = e;
        if(value.indexOf(".")<0){
          value = value.slice(0,9)
        }
        if(value.indexOf(".")>=9){
          value = value.slice(0,9) + value.slice(value.indexOf("."))
        }

        value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
        value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
        value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        value = value.replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, "$1$2.$3"); //只能输入两个小数
        if (value.indexOf(".") < 0 && value != "") {
          //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
          value = parseFloat(value);
        }
        if(value=='.'){
          value = '0.'
        }
        return value;
      },
      // 输入止码方法
      inputnowNumsdata(row,value){
        value = this.omitNumber(value);
        row.nowNums = value;
        this.$forceUpdate();
      },
      // 对比上期的止码
      nowNumsdata(oldvals,newnums){
         let oldNums=oldvals.endNum;
         let nums;

          if (newnums == undefined){
            oldvals.nowEnergy="";
          }else if(parseFloat(newnums)<parseFloat(oldNums)){
            this.$message({
              message: '输入值小于上期止码！',
              type: 'warning'
            });
          oldvals.nowEnergy="";
        }else{
            this.form.newnums=newnums;
          nums=newnums-oldNums
          nums=parseFloat(nums).toFixed(4);
          oldvals.nowEnergy=nums;
            this.form.nowEnergy=nums;
        }

      },
      meterTypeChange(value){
        this.meterModelList = this.meterModelAllList.filter(model => {
          return model.meterType +'' === value +'';
        });
        this.form.meterModelId = '';
      },
      searchAreaNodeTreeClick(node){
        this.query.areaId = node.id;
        this.query.areaName = node.name;
      },
      searchAreaLazyLoadTree(node,resolve) {
        // 当项目为空的时候就不加载区域树
        if(!this.query.projectId){
          return;
        }
        let id ;
        if (node.level === 0) {
          id = 0;
        } else {
          id = node.data.id;
        }
        lazyTree({ parentId: id, projectId: this.query.projectId }).then(({ data }) => {
          if (data instanceof Array) {
            data.forEach((item) => {
              item.hasChildren = !item.hasChildren;
            });
          }
          resolve(data);
        });
      },

      closeDialog(){
        this.showOperateDialog = false;
        this.form = {
          projectId: '',
          areaId: '',
          areaName:'',
          meterType:'',
          collectTime:''
        }
      },
      searchReset() {
        this.query = {
          projectId: '',
          areaId: '',
          areaName:'',
          meterType:'',
        };
        if (this.projectList.length > 0) {
          this.query.projectId = this.projectList[0].id;
          // this.initAreaList();
        }
        this.onLoad();
      },

      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        if(this.onLoadFlag){
          return;
        }
        page = page || this.page;
        this.loading = true;
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
          console.log(this.form)
        });
      },
      // 切换仪表类型 区域 时 获取仪表list
      projectSearchChange(){
        this.getParamsData();
      },
      // 初始化获取区域树数据
      initAreaList(){
        lazyTree({ parentId: 0, projectId: this.query.projectId }).then(({ data }) => {
          if (data instanceof Array) {
            data.forEach((item) => {
              item.hasChildren = !item.hasChildren;
            });
          }
          this.treeFormAreaData = data;
          this.query.areaName='';
          this.query.areaId='';
        });
      },
    }
  };

</script>
